<template>
  <div style="padding: 15px" class="bg-white" label-position="top">
    <el-row>
      <el-col :sm="12">
        <h4 class="form-title">Repair - ULD Out</h4>
      </el-col>
      <el-col :span="12" :md="{ span: 4, offset: 8 }">
        <el-form label-position="left">
          <el-form-item>
            <el-input
              type="text"
              v-model="searchKey"
              placeholder="Search ULD Out No."
              @keydown.native.enter.prevent="fetch(1)"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click.prevent="fetch(1)"
              >
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- <el-col :sm="12">
        <div class="d-flex justify-content-flex-end">
          <el-button type="primary" size="small" @click="openDrawer"
            >Add ULD Out</el-button
          >
        </div>
      </el-col> -->
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="list.data" v-loading="isLoading">
          <el-table-column label="Actions" width="80">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-folder"
                title="Open ULD Out"
                circle
                size="small"
                @click="view(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column
            min-width="80px"
            label="Delivery Number"
            prop="batch_no"
          >
          </el-table-column>
          <!-- <el-table-column
            min-width="150px"
            label="Job Order No."
            prop="job_order_number"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.job_order_number }}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="150px"
            label="ULD ID Code - Serial No."
            prop="uld_id_code"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.uld_id_code }}</span> -
              <span>{{ scope.row.tso_ser_no }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            min-width="100px"
            label="Delivery Date"
            prop="delivery_date"
          >
            <template slot-scope="scope">
              {{ scope.row.delivery_date | dateFormat }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row type="flex">
      <el-col :sm="24" :md="12">
        <el-pagination
          v-show="!isLoading"
          class="pt-1 pb-1"
          background
          layout="prev, pager, next"
          :total="list.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(list.paging.cur_page)"
          @current-change="fetch"
        ></el-pagination>
      </el-col>
    </el-row>
    <app-drawer ref="drawer" @close="resetForm">
      <div class="el-drawer__content" v-loading="isLoading">
        <el-form
          ref="addForm"
          label-position="left"
          :model="formModel"
          :rules="rules"
        >
          <el-alert
            show-icon
            id="top-alert"
            type="info"
            :closable="false"
            effect="dark"
          >
            Delivery number will generate once submitted.
          </el-alert>
          <el-row :gutter="15">
            <el-col :md="24" :sm="24">
              <el-form-item label="Delivery Date" prop="delivery_date">
                <el-date-picker
                  type="date"
                  v-model="formModel.delivery_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="is_jettainer">
                <el-checkbox v-model="formModel.is_jettainer"
                  >Is Jettainer</el-checkbox
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-table :data="formModel.list">
                <el-table-column label="Actions" width="80">
                  <template slot-scope="scope">
                    <el-button
                      type="danger"
                      circle
                      icon="el-icon-delete"
                      @click="removeULD(scope.row)"
                    >
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="ULD Code">
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.uld_id_code"
                      filterable
                      clearable
                      remote
                      :remote-method="findMasterlist"
                      @change="searchForULD(scope.row, $event)"
                    >
                      <el-option
                        v-for="code in codes"
                        :key="code.id"
                        :value="code.id"
                        :label="code.uld_id_code"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column min-width="150px" label="Job Order No.">
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.id"
                      filterable
                      clearable
                      @change="addNewRow"
                    >
                      <el-option
                        v-for="jo in scope.row.uld_list"
                        :key="jo.id"
                        :value="jo.id"
                        :label="jo.job_order_number"
                        :disabled="isSelected(jo)"
                      ></el-option>
                    </el-select>
                    <div v-if="scope.row.notes" class="mt-1">
                      <el-alert
                        :closable="false"
                        v-if="
                          scope.row.notes &&
                            ('error' in scope.row.notes ||
                              scope.row.notes.code != 200)
                        "
                        type="error"
                        >{{ scope.row.notes.message }}</el-alert
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-form>
        <div class="el-drawer__footer">
          <el-button
            size="small"
            type="primary"
            @click="batchSave"
            :disabled="isLoading"
            >Save</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="addULD"
            :disabled="isLoading"
            >Add ULD</el-button
          >
        </div>
      </div>
    </app-drawer>
  </div>
</template>

<script>
import Masterlist from "@/models/Masterlist";
import ULD from "@/models/ULD";
import moment from "moment";
export default {
  name: "ULD_Out",
  data: () => ({
    isLoading: false,
    searchKey: "",
    list: { data: [], paging: {} },
    pager: { limit: 25 },
    formModel: {
      uldin_id: "",
      delivery_date: "",
      is_jettainer: false,
      list: [
        {
          id: "",
          uld_id_code: "",
          uld_list: [],
          jo_number: "",
          notes: null,
          _id: Date.now()
        }
      ]
    },
    rules: {
      uldin_id: [
        { required: true, message: "ULD Code is required.", trigger: "change" }
      ],
      delivery_date: [
        {
          required: true,
          message: "Delivery Date is required.",
          trigger: "blur"
        }
      ]
    },
    codes: [],
    uldList: [],
    usedULD: []
  }),
  methods: {
    view(uld) {
      // this.$router.push({
      //   name: "repairULD_Out_Info",
      //   params: { id: uld.batch_id }
      // });
      window.open(`/print/repair-uld-out/${uld.batch_id}`);
    },
    fetch(page) {
      this.isLoading = true;
      let params = { page: 1, limit: this.pager.limit };
      if (page) {
        params.page = page;
      }
      if (this.searchKey) {
        params.search = parseInt(this.searchKey);
      }
      ULD.get_uld_out(params).then(resp => {
        this.list = resp;
        this.isLoading = false;
      });
    },
    openDrawer() {
      this.$refs.drawer.open();
    },
    findMasterlist(queryString) {
      if (queryString.length >= 3) {
        Masterlist.searchUld({ q: queryString, limit: 15, uldout: 1 }).then(
          resp => {
            if (resp.length) {
              for (let uld of resp) {
                let check = this.codes.find(o => o.id == uld.id);
                if (!check) {
                  this.codes.push({ ...uld });
                }
              }
            }
          }
        );
      }
    },
    searchForULD(row, $event) {
      if (!$event) {
        // this.formModel.list = [];
        row.uld_list = [];
        row.id = "";
        return false;
      }

      // check if all uld_list item is used
      if ($event) {
        let usedULD = this.codes.find(o => o.id == $event);
        let unusedJO = [];
        if (usedULD != undefined) {
          if (usedULD.hasOwnProperty("jo_list")) {
            for (let item of usedULD.jo_list) {
              let check = this.formModel.list.find(o => o.id == item.id);
              if (!check) {
                unusedJO.push(item);
              }
            }
            if (unusedJO.length == 0) {
              row.uld_id_code = "";
              row.id = "";
              return false;
            } else {
              row.uld_list = usedULD.jo_list;
              row.id = unusedJO[0].id;
              if (unusedJO.length > 1) {
                let i = 0;
                for (let uld of unusedJO) {
                  if (i != 0) {
                    this.formModel.list.push({
                      id: uld.id,
                      uld_id_code: $event,
                      jo_number: "",
                      uld_list: usedULD.jo_list,
                      notes: null,
                      _id: Date.now()
                    });
                  }
                  i++;
                }
              }
              return false;
            }
          }
        }
      }

      let params = {
        masterlist_id: $event
      };
      ULD.get_jo_no(params).then(resp => {
        let code = this.codes.find(o => o.id == $event);
        code.jo_list = resp.data;
        row.uld_list = resp.data;
        row.id = resp.data[0].id;
        if (resp.data.length > 1) {
          let i = 0;
          for (let uld of resp.data) {
            if (i != 0) {
              this.formModel.list.push({
                id: uld.id,
                uld_id_code: row.uld_id_code,
                jo_number: "",
                uld_list: resp.data,
                notes: null,
                _id: Date.now()
              });
            }
            i++;
          }
        }
        this.addULD();
        //   this.formModel.list = [];
      });
    },
    resetForm() {
      this.codes = [];
      this.formModel = {
        uldin_id: "",
        delivery_date: "",
        is_jettainer: false,
        list: [
          { id: "", uld_id_code: "", uld_list: [], jo_number: "", notes: null }
        ]
      };
    },
    addULD() {
      let check = this.formModel.list.find(o => o.id == "");
      if (!check) {
        let _id = Date.now();
        let check = this.formModel.list.find(o => o._id == _id);
        if (check) {
          _id = Date.now() + Date.now();
        }
        this.formModel.list.push({
          id: "",
          uld_id_code: "",
          uld_list: [],
          jo_number: "",
          notes: null,
          _id: _id
        });
      }
    },
    addNewRow() {
      let filled = this.formModel.list.find(o => o.id == "");
      if (!filled) {
        this.addULD();
      }
    },
    removeULD(uld) {
      this.formModel.list = this.formModel.list.filter(o => o._id != uld._id);
    },
    isSelected(uld) {
      if (this.formModel.list.find(o => o.id == uld.id)) {
        return true;
      }
      return false;
    },
    batchSave() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return false;
        this.isLoading = true;
        // var hasError = false;

        // let promises = [];
        // this.formModel.list.forEach(item => {
        //   if (!item.id) return;
        //   let payload = {
        //     delivery_date: moment(this.formModel.delivery_date).format(
        //       "YYYY-MM-DD"
        //     ),
        //     uldin_id: item.id
        //   };

        //   promises.push(
        //     ULD.post_uld_out(payload).then(resp => {
        //       //   console.log(resp);
        //       if ("error" in resp.data || resp.data.code != 200) {
        //         item.notes = resp.data;
        //         hasError = true;
        //       }
        //     })
        //   );
        // });

        // Promise.all(promises).then(() => {
        //   if (hasError) {
        //     // remove all rows without error
        //     this.formModel.list = this.formModel.list.filter(
        //       o => o.notes != null
        //     );
        //     this.$notify({
        //       position: "bottom-right",
        //       message: "Done saving ULD Out with erros.",
        //       type: "warning"
        //     });
        //   } else {
        //     //   clear the form and close the drawer
        //     this.$refs.drawer.close();
        //     this.formModel = {
        //       uldin_id: "",
        //       delivery_date: "",
        //       list: []
        //     };
        //     this.$refs.addForm.clearValidate();
        //     this.$notify({
        //       position: "bottom-right",
        //       message: "Done saving ULD Out.",
        //       type: "success"
        //     });
        //   }
        //   this.fetch();
        //   this.isLoading = false;
        // });

        // use comma delimited
        let payload = {
          delivery_date: moment(this.formModel.delivery_date).format(
            "YYYY-MM-DD"
          ),
          is_jettainer: this.formModel.is_jettainer ? 1 : 0,
          uldin_id: ""
        };
        let csv = this.formModel.list.filter(o => o.id != "").map(o => o.id);
        if (csv.length) {
          payload.uldin_id = csv;
          ULD.post_uld_out(payload).then(resp => {
            if (resp.code == 200) {
              this.$notify({
                position: "bottom-right",
                message: "Done saving ULD Out.",
                type: "success"
              });
            }
            this.isLoading = false;
            this.$refs.drawer.close();
            this.fetch();
          });
        }
      });
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    .el-alert {
      padding: 3px 5px;
    }
    .el-alert__description {
      margin-top: 0;
    }
  }
  #top-alert {
    .el-alert__description {
      margin-top: 0;
      font-size: 14px;
    }
  }
}
</style>
